import React from "react";

export default function ConfirmDelete({ deleteUser,cancelRequest, id }) {
  return (
    <div className="confirm-delete-wrapper register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>Are you sure?</h3>
              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  Cancel
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={deleteUser}
                >
                  Delete
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
